import React from 'react'

const LoaderSpinner = props => (
  <div style={props.style}>
    <div className="loader">
      <button className="pulse-button" />
    </div>
  </div>
)
export default LoaderSpinner



// WEBPACK FOOTER //
// ./src/views/Widgets/LoaderSpinner.js